import React from 'react';
import { Phone, Mail, MapPin, MessageCircle, Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleWhatsApp = () => {
    window.open('https://wa.me/919694612895', '_blank');
  };

  return (
    <footer id="contact" className="bg-gray-950 border-t border-gray-900">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src="https://customer-assets.emergentagent.com/job_hackademics/artifacts/0t3ay2r3_icc_logo_red_without_bg-removebg-preview.png"
                alt="Indian Cyber Club Academy"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              India's leading cybersecurity training academy with 340K+ followers. Master ethical hacking, penetration testing, and security skills from industry experts.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/p/Indian-cyber-club-100076742166367/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5 text-gray-400 hover:text-white" />
              </a>
              <a href="https://www.instagram.com/indian_cyber_club/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5 text-gray-400 hover:text-white" />
              </a>
              <a href="https://www.youtube.com/@AbhishekParashar-ICC" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Youtube className="w-5 h-5 text-gray-400 hover:text-white" />
              </a>
              <a href="https://www.linkedin.com/company/indian-cyber-club-technologies/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5 text-gray-400 hover:text-white" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  About Us
                </a>
              </li>
              <li>
                <a href="/testimonials" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Testimonials
                </a>
              </li>
              <li>
                <a href="/companies" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Companies
                </a>
              </li>
              <li>
                <a href="/verify-certificate" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Verify Certificate
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Popular Courses</h3>
            <ul className="space-y-3">
              <li>
                <a href="/#courses" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Ethical Hacking
                </a>
              </li>
              <li>
                <a href="/#courses" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  SOC Analyst
                </a>
              </li>
              <li>
                <a href="/#courses" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Bug Bounty
                </a>
              </li>
              <li>
                <a href="/#courses" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  VAPT Training
                </a>
              </li>
              <li>
                <a href="/#courses" className="text-gray-400 hover:text-red-500 transition-colors flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-2 h-px bg-red-500 transition-all duration-300"></span>
                  Digital Forensics
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-400">
                <Phone className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
                <div>
                  <a href="tel:+919694612895" className="hover:text-white transition-colors">
                    +91 96946 12895
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Mail className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
                <div>
                  <a href="mailto:info@indiancyberclub.com" className="hover:text-white transition-colors">
                    info@indiancyberclub.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-white font-bold mb-1">Indian Cyber Club Academy</div>
                  <div>Jaipur, Rajasthan, India</div>
                  <div className="mt-2 text-sm">
                    <span className="text-red-500">Offline Training:</span> Jaipur<br />
                    <span className="text-red-500">Online Courses:</span> All India
                  </div>
                </div>
              </li>
              <li>
                <button
                  onClick={handleWhatsApp}
                  className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors mt-2"
                >
                  <MessageCircle className="w-4 h-4" />
                  Chat on WhatsApp
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-900">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Indian Cyber Club Academy. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-4 md:gap-6 text-sm justify-center">
              <a href="/privacy-policy" className="text-gray-400 hover:text-red-500 transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-conditions" className="text-gray-400 hover:text-red-500 transition-colors">
                Terms & Conditions
              </a>
              <a href="/refund-policy" className="text-gray-400 hover:text-red-500 transition-colors">
                Refund Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
